export const designTypesEnum = Object.freeze({
    BACK: "back",
    HALF_SLEEVES: "halfSleeves",
    FULL_SLEEVES: "fullSleeves",
    A4: "a4",
    A3: "a3",
    A2: "a2",
    A1: "a1",
    CUSTOM: "custom",
});
